export const defaultTheme = {
  // font color
  colors: {
    primary: "#fff",
    secondary: "#fff",
    success: "#fff",
    warning: "#333",
    danger: "#fff",
    info: "#fff",
    dark: "#fff",
    light: "#333",
    "outline-primary": "#0074F0",
    "outline-secondary": "#6C757D",
    "outline-success": "#28A745",
    "outline-warning": "#FFC107",
    "outline-danger": "#DC3545",
    "outline-info": "#17A2B8",
    "outline-dark": "#343A40",
    "outline-light": "#F8F9FA"
  },
  // background color for buttons
  btnStyles: {
    primary: "#0074F0",
    secondary: "#6C757D",
    success: "#28A745",
    warning: "#FFC107",
    danger: "#DC3545",
    info: "#17A2B8",
    dark: "#343A40",
    light: "#F8F9FA",
    "outline-primary": "transparent",
    "outline-secondary": "transparent",
    "outline-success": "transparent",
    "outline-warning": "transparent",
    "outline-danger": "transparent",
    "outline-info": "transparent",
    "outline-dark": "transparent",
    "outline-light": "transparent"
  },
  // border styles for buttons and inputs
  borderStyles: {
    primary: "none",
    secondary: "none",
    success: "none",
    warning: "none",
    danger: "none",
    info: "none",
    dark: "none",
    light: "none",
    "outline-primary": "1px solid #0074F0",
    "outline-secondary": "1px solid #6C757D",
    "outline-success": "1px solid #28A745",
    "outline-warning": "1px solid #FFC107",
    "outline-danger": "1px solid #DC3545",
    "outline-info": "1px solid #17A2B8",
    "outline-dark": "1px solid #343A40",
    "outline-light": "1px solid #F8F9FA"
  },
  // border radius styles
  borderRadius: {
    primary: "5px",
    square: "none",
    rounded: "25px"
  }
};
